import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import Moment from 'react-moment';
import moment from 'moment';
import { useTranslation, Trans } from 'react-i18next';

const LicenseItem = ({
  auth,
  license: {
    _id,
    licenseId,
    type,
    entity,
    startDate,
    endDate,
    descriptionADV,
    descriptionAdminEntity,
    status
  }
}) => {
  const { t } = useTranslation();

  return (
    <Fragment>
      <tr>
        <td className="text-center ">
          {status === 'activated' ? (
            <div className="text-center align-middle badge badge-pill badge-success p-2 mb-2 ">
              <Trans>{t('activated')}</Trans>
            </div>
          ) : status === 'disabled' ? (
            <div className="badge badge-pill badge-danger  p-2 mb-2 ">
              <Trans>{t('deactivated')}</Trans>
            </div>
          ) : status === 'finished' ? (
            <div className="badge badge-pill badge-danger  p-2 mb-2 ">
              <Trans>{t('finished')}</Trans>
            </div>
          ) : status === 'expired' ? (
            <div className="badge badge-pill badge-warning  p-2 mb-2 ">
              <Trans>{t('expired')}</Trans>
            </div>
          ) : (
            <div className="badge badge-pill badge-danger  p-2 mb-2 ">
              <Trans>{t('deactivated')}</Trans>
            </div>
          )}
        </td>
        <td className="text-center align-middle">{type}</td>
        <td className="text-center align-middle ">
          <Link to={`/license/${_id}`}>
            <span className="text-center align-middle">{licenseId}</span>
          </Link>
        </td>
        {auth.user.rights === 'admin' || auth.user.rights === 'ADV' ? (
          <td className="text-center align-middle hide-mobile">
            {descriptionADV}
          </td>
        ) : null}
        <td className="text-center align-middle hide-mobile">
          {descriptionAdminEntity}
        </td>
        {auth.user.rights === 'admin' || auth.user.rights === 'ADV' ? (
          <td className="text-center align-middle hide-mobile">{entity}</td>
        ) : null}
        <td className="text-center align-middle hide-mobile" width="100">
          <Moment format=" DD/MM/YYYY">{moment(startDate).local()}</Moment>
        </td>
        <td className="text-center align-middle hide-mobile" width="100">
          <Moment format=" DD/MM/YYYY">{moment(endDate).local()}</Moment>
        </td>
      </tr>
    </Fragment>
  );
};

LicenseItem.propTypes = {
  license: PropTypes.object.isRequired,
  auth: PropTypes.object.isRequired
};

export default LicenseItem;
